import { Injectable } from '@angular/core';
import { HttpService } from '../services/http.service';

@Injectable()
export class PatternInvestigationPopupService {

  public sickLeave;

  constructor(public httpService: HttpService) {
  }

  getCertificatesForComparison(absenceid, employeeid) {
    const body = {
      'appLang': 'fr',
      'absenceID': absenceid,
      'employeeID': employeeid
    };
    // return this.httpService.post('https://40n4ewvu2c.execute-api.eu-west-1.amazonaws.com/sit/getcertificatecomparisionapi', body)
    return this.httpService.post('/hradmin/getCertificateComparision', body)
  }

}


// WEBPACK FOOTER //
// ./src/app/services/pattern-investigation-popup.service.ts